(function () {
  var cachedConfig = null;

  function isEnabledValue(value) {
    return value === true || value === "true";
  }

  function normalizeMarginConfig(input) {
    if (!input || typeof input !== "object") {
      return {
        enabled: false,
        type: "fixed",
        fixed: 0,
        percentage: 0,
        compareAtEnabled: false,
        compareAtType: "fixed",
        compareAtAmount: 0,
        compareAtPercentage: 0,
        sellingBadgeEnabled: false,
        sellingBadgeText: "",
      };
    }

    var type = input.type === "percentage" ? "percentage" : "fixed";
    var compareAtType =
      input.compareAtType === "percentage" ? "percentage" : "fixed";
    var badgeText =
      input.sellingBadgeText == null ? "" : String(input.sellingBadgeText).trim();
    return {
      enabled: isEnabledValue(input.enabled),
      type: type,
      fixed: Math.max(0, Number(input.fixed) || 0),
      percentage: Math.max(0, Math.min(100, Number(input.percentage) || 0)),
      compareAtEnabled: isEnabledValue(input.compareAtEnabled),
      compareAtType: compareAtType,
      compareAtAmount: Math.max(0, Number(input.compareAtAmount) || 0),
      compareAtPercentage: Math.max(
        0,
        Math.min(100, Number(input.compareAtPercentage) || 0),
      ),
      sellingBadgeEnabled: isEnabledValue(input.sellingBadgeEnabled),
      sellingBadgeText: badgeText,
    };
  }

  function readFromRoot() {
    var root = document.querySelector("[data-ring-builder-diamonds]");
    if (!root || !root.hasAttribute("data-diamond-margin-enabled")) {
      return null;
    }

    return normalizeMarginConfig({
      enabled: root.getAttribute("data-diamond-margin-enabled"),
      type: root.getAttribute("data-diamond-margin-type"),
      fixed: root.getAttribute("data-diamond-margin-fixed"),
      percentage: root.getAttribute("data-diamond-margin-percentage"),
      compareAtEnabled: root.getAttribute("data-diamond-compare-at-enabled"),
      compareAtType: root.getAttribute("data-diamond-compare-at-type"),
      compareAtAmount: root.getAttribute("data-diamond-compare-at-amount"),
      compareAtPercentage: root.getAttribute("data-diamond-compare-at-percentage"),
      sellingBadgeEnabled: root.getAttribute("data-diamond-selling-badge-enabled"),
      sellingBadgeText: root.getAttribute("data-diamond-selling-badge-text"),
    });
  }

  function readConfig() {
    if (cachedConfig) return cachedConfig;

    var fromRoot = readFromRoot();
    if (fromRoot) {
      cachedConfig = fromRoot;
      return cachedConfig;
    }

    var el = document.getElementById("ring-builder-diamond-margin-config");
    if (!el) {
      cachedConfig = normalizeMarginConfig(null);
      return cachedConfig;
    }

    try {
      cachedConfig = normalizeMarginConfig(JSON.parse(el.textContent));
    } catch (e) {
      cachedConfig = normalizeMarginConfig(null);
    }

    return cachedConfig;
  }

  function nivodaCentsToDollars(cents) {
    var amount = Number(cents);
    if (!isFinite(amount)) return 0;
    return amount / 100;
  }

  function applyMarginDollars(baseDollars, config) {
    var base = Math.max(0, Number(baseDollars) || 0);
    var cfg = config || readConfig();

    if (!cfg.enabled) {
      return base;
    }

    if (cfg.type === "percentage") {
      return base * (1 + cfg.percentage / 100);
    }

    return base + cfg.fixed;
  }

  function applyMarginToNivodaCents(cents, config) {
    return applyMarginDollars(nivodaCentsToDollars(cents), config);
  }

  function compareAtDollars(cents, config) {
    var cfg = config || readConfig();
    if (!cfg.compareAtEnabled) {
      return 0;
    }

    var retail = applyMarginToNivodaCents(cents, cfg);

    if (cfg.compareAtType === "percentage") {
      if (cfg.compareAtPercentage <= 0) return 0;
      return retail * (1 + cfg.compareAtPercentage / 100);
    }

    if (cfg.compareAtAmount <= 0) return 0;
    return retail + cfg.compareAtAmount;
  }

  function moneyFormatNoDecimals(format) {
    return String(format || "${{amount}}")
      .replace(
        /\{\{\s*amount_with_comma_separator\s*\}\}/g,
        "{{amount_no_decimals_with_comma_separator}}",
      )
      .replace(
        /\{\{\s*amount_with_space_separator\s*\}\}/g,
        "{{amount_no_decimals_with_space_separator}}",
      )
      .replace(
        /\{\{\s*amount_with_apostrophe_separator\s*\}\}/g,
        "{{amount_no_decimals}}",
      )
      .replace(/\{\{\s*amount\s*\}\}/g, "{{amount_no_decimals}}");
  }

  function formatMoneyDollars(dollars, rounded) {
    var value = rounded ? Math.round(dollars) : dollars;

    if (
      window.theme &&
      window.theme.Currency &&
      typeof window.theme.Currency.formatMoney === "function"
    ) {
      var format = rounded
        ? moneyFormatNoDecimals(window.theme.moneyFormat)
        : window.theme.moneyFormat;
      return window.theme.Currency.formatMoney(
        Math.round(value * 100),
        format,
      );
    }

    if (rounded) {
      return "$" + value.toLocaleString();
    }
    return (
      "$" +
      value.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    );
  }

  function formatCompareAtMoney(cents, config) {
    var dollars = compareAtDollars(cents, config);
    if (dollars <= 0) return "";
    return formatMoneyDollars(dollars, true);
  }

  function formatCompareAtMoneyRounded(cents, config) {
    return formatCompareAtMoney(cents, config);
  }

  function formatDiscountBadgePercent(retailDollars, compareAtDollarValue) {
    var retail = Math.round(Math.max(0, Number(retailDollars) || 0));
    var compareAt = Math.round(Math.max(0, Number(compareAtDollarValue) || 0));
    if (compareAt <= retail || compareAt <= 0) return "";
    var percent = Math.round(((compareAt - retail) / compareAt) * 100);
    if (percent <= 0) return "";
    return percent + "% OFF";
  }

  function getSellingBadge(config, cents) {
    var cfg = config || readConfig();
    if (!cfg.sellingBadgeEnabled) return "";
    if (cfg.sellingBadgeText) return cfg.sellingBadgeText;
    if (cents == null) return "";
    var retail = applyMarginToNivodaCents(cents, cfg);
    var compareAt = compareAtDollars(cents, cfg);
    return formatDiscountBadgePercent(retail, compareAt);
  }

  function formatRetailMoney(cents, config) {
    return formatMoneyDollars(applyMarginToNivodaCents(cents, config), true);
  }

  function formatRetailMoneyRounded(cents, config) {
    return formatRetailMoney(cents, config);
  }

  function getMarginPayload(config) {
    var cfg = config || readConfig();
    return {
      enabled: cfg.enabled === true,
      type: cfg.type,
      fixed: cfg.fixed,
      percentage: cfg.percentage,
      compareAtEnabled: cfg.compareAtEnabled === true,
      compareAtType: cfg.compareAtType,
      compareAtAmount: cfg.compareAtAmount,
      compareAtPercentage: cfg.compareAtPercentage,
      sellingBadgeEnabled: cfg.sellingBadgeEnabled === true,
      sellingBadgeText: cfg.sellingBadgeText,
    };
  }

  window.RingBuilderDiamondMargin = {
    readConfig: readConfig,
    normalizeMarginConfig: normalizeMarginConfig,
    nivodaCentsToDollars: nivodaCentsToDollars,
    applyMarginDollars: applyMarginDollars,
    applyMarginToNivodaCents: applyMarginToNivodaCents,
    formatRetailMoney: formatRetailMoney,
    formatRetailMoneyRounded: formatRetailMoneyRounded,
    compareAtDollars: compareAtDollars,
    formatCompareAtMoney: formatCompareAtMoney,
    formatCompareAtMoneyRounded: formatCompareAtMoneyRounded,
    getSellingBadge: getSellingBadge,
    getMarginPayload: getMarginPayload,
  };
})();
